/* eslint-disable import/named */
import React, { useState } from 'react';
import SEO from '../components/seo';
import { Titre } from '../components/titre';
import { Section0Accueil } from '../components/section0-accueil';
import { Section1Presentation } from '../components/section1-presentation';
import { Section2Collecte } from '../components/section2-collecte';
import { Section3Jeunes } from '../components/section3-jeunes';
import { Section4Dessiner } from '../components/section4-dessiner';
import { Section5Afficher } from '../components/section5-afficher';
import { Section6Chanter } from '../components/section6-chanter';
import { Section7Jouer } from '../components/section7-jouer';
import { Section8Remerciements } from '../components/section8-remerciements';
import { Layout } from '../components/layout';
import { SocialMedia } from '../components/social-media';
import { Footer } from '../components/footer';
import { VideoModal } from '../components/video-modal';
import { ImgModal } from '../components/img-modal';

const IndexPage = () => {
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [videoModalSrc, setVideoModalSrc] = useState('');
  const [imgModalOpen, setImgModalOpen] = useState(false);
  const [imgModalSrc, setImgModalSrc] = useState('');

  // meta for SEO are only available on prod (@see .env.production/.env.development)
  const meta = [{
    name: 'robots',
    content: process.env.GATSBY_ACTIVE_ENV === 'production' ? 'index,follow' : 'noindex,nofollow',
  }];

  return (
    <Layout>
      <SEO
        title="Regards d'enfants sur les violences basées sur le genre"
        lang="fr"
        meta={meta}
      />
      <Titre />
      <Section0Accueil />
      {/* <Header /> */}
      <main>
        <Section1Presentation />
        <Section2Collecte />
        <Section3Jeunes setVideoModalOpen={setVideoModalOpen} setVideoModalSrc={setVideoModalSrc} />
        <Section4Dessiner setImgModalOpen={setImgModalOpen} setImgModalSrc={setImgModalSrc} />
        <Section5Afficher setImgModalOpen={setImgModalOpen} setImgModalSrc={setImgModalSrc} />
        <Section6Chanter setVideoModalOpen={setVideoModalOpen} setVideoModalSrc={setVideoModalSrc} />
        <Section7Jouer setImgModalOpen={setImgModalOpen} setImgModalSrc={setImgModalSrc} />
        <Section8Remerciements />

      </main>
      <Footer />
      <SocialMedia />
      <VideoModal open={videoModalOpen} setter={setVideoModalOpen} src={videoModalSrc} />
      <ImgModal open={imgModalOpen} setter={setImgModalOpen} src={imgModalSrc} />
    </Layout>
  );
};

export default IndexPage;
